import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { AlertStateChange } from "@app2/clients/types/alert-typedefs";
import { PRODUCT_DOMAIN } from "@app2/alert/alert-inbox/injection-tokens";
import { Domain } from "@app2/alert/constants";

type Option = {
    key: string;
    keyMulti: string;
    newState: string;
    icon: string;
};

@Component({
    selector: "alert-state-changer",
    template: `
        <ul class="button-group" *dsPermissionsRequired="'ALERT_INBOX_EDIT'">
            <li *ngIf="loading">
                <i class="fa fa-spinner fa-spin extra-right-margin"></i>
            </li>
            <ng-container *ngIf="!loading">
            <li *ngFor="let change of changes">
                <escalate-dropdown *ngIf="change.newState === 'ESCALATED' && currentState !== 'ESCALATED'"
                                   [loading]="loading"
                                   [multipleAlerts]="allForTrigger"
                                   [buttonTooltip]="allForTrigger ? 'ESCALATE_30D' : 'ESCALATE'"
                                   (onEscalate)="onStateChange.emit({oldState: currentState, newState: change.newState, ticketSlugName: $event.slugName, ticketSlugId: $event.slugId})">
                </escalate-dropdown>
                <dismiss-button *ngIf="change.newState === 'DISMISSED' && currentState !== change.newState && !escalateOnly"
                                [currentState]="currentState"
                                [currentTriggerName]="currentTriggerName"
                                [loading]="loading"
                                [allForTrigger]="allForTrigger"
                                [shouldShowBulkLines]="true"
                                (onSubmit)="onStateChange.emit($event)"></dismiss-button>
                <flag-fraud-button *ngIf="change.newState === 'FRAUD_FLAGGED' && currentState !== change.newState && inboxDomain === 'FRAUD' && !escalateOnly"
                                   [currentState]="currentState"
                                   [currentTriggerName]="currentTriggerName"
                                   [loading]="loading"
                                   [allForTrigger]="allForTrigger"
                                   [shouldShowBulkLines]="true"
                                   (onSubmit)="onStateChange.emit($event)">
                </flag-fraud-button>
                <button
                    *ngIf=" !['ESCALATED', 'DISMISSED', 'FRAUD_FLAGGED'].includes(change.newState) && change.newState !== currentState && !escalateOnly"
                    class="button link secondary borderless"
                    [ngClass]="{'disabled-button': loading}"
                    (click)="onStateChange.emit({oldState: currentState, newState: change.newState})"
                    [disabled]="loading"
                    [attr.test-class]="'state-change-button-' + change.newState"
                    [matTooltip]="(allForTrigger ? change.keyMulti : change.key) | localize">
                    <div class="action-icon">
                        <img *ngIf="allForTrigger"
                             class="bulk-lines"
                             src="assets/icons/alert-action-bulk-lines.svg"/>
                        <i class="{{ change.icon }}"></i>
                    </div>
                </button>
            </li>
            </ng-container>
        </ul>`,
    styles: [`
        .extra-right-margin {
            margin-right: 1rem;
        }`,
    ],
})
export class AlertStateChangerComponent {
    @Input() currentState: string;
    @Input() currentTriggerName: string;
    @Input() loading: boolean;
    @Input() allForTrigger?: boolean;
    @Input() escalateOnly: boolean;
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onStateChange = new EventEmitter<AlertStateChange>();

    changes: Option[] = [{
        key: "NEW",
        keyMulti: "NEW_30D",
        newState: "NEW",
        icon: "far fa-circle",
    }, {
        key: "ACK",
        keyMulti: "ACK_30D",
        newState: "ACKED",
        icon: "fas fa-check",
    }, {
        key: "ESCALATE",
        keyMulti: "ESCALATE_30D",
        newState: "ESCALATED",
        icon: "fas fa-triangle-exclamation",
    }, {
        key: "FLAG_FRAUD",
        keyMulti: "FLAG_FRAUD_30D",
        newState: "FRAUD_FLAGGED",
        icon: undefined,
    }, {
        key: "DISMISS",
        keyMulti: "DISMISS_30D",
        newState: "DISMISSED",
        icon: "fas fa-xmark",
    }];

    constructor(@Inject(PRODUCT_DOMAIN) private inboxDomain: Domain) {
    }
}
